/* Wallview — frontend controller for "Duvarında gör" modal */
(function () {
  'use strict';

  const API_BASE = '/apps/wallview/api';
  const cfg = window.WALLVIEW_CONFIG || {};

  const modal     = document.getElementById('wv-modal');
  if (!modal) return;

  const stateEls  = modal.querySelectorAll('[data-wv-state]');
  const dropZone  = modal.querySelector('[data-wv-drop]');
  const fileInput = modal.querySelector('[data-wv-input]');
  const preview   = modal.querySelector('[data-wv-preview]');
  const dropInner = modal.querySelector('.wv-drop__inner');
  const genBtn    = modal.querySelector('[data-wv-generate]');
  const quotaEl   = modal.querySelector('[data-wv-quota]');
  const quotaAfter= modal.querySelector('[data-wv-quota-after]');
  const statusEl  = modal.querySelector('[data-wv-status]');
  const resultImg = modal.querySelector('[data-wv-result]');
  const dlBtn     = modal.querySelector('[data-wv-download]');
  const errMsg    = modal.querySelector('[data-wv-error-msg]');

  let chosenFile = null;

  // ── Open / close ──────────────────────────────────────────────────
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-wv-open]');
    if (trigger) { e.preventDefault(); openModal(); }
    if (e.target.closest('[data-wv-close]')) closeModal();
    if (e.target.closest('[data-wv-restart]')) showState('upload');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    if (!cfg.isLoggedIn) {
      showState('login');
      return;
    }
    showState('upload');
    loadQuota();
  }
  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    resetUploadUI();
  }
  function showState(name) {
    stateEls.forEach((el) => { el.hidden = el.getAttribute('data-wv-state') !== name; });
  }

  // ── Quota ─────────────────────────────────────────────────────────
  async function loadQuota() {
    if (quotaEl) quotaEl.textContent = 'Hak bilgisi yükleniyor…';
    try {
      const resp = await fetch(`${API_BASE}/quota`, { credentials: 'include' });
      const data = await resp.json();
      if (!resp.ok) throw new Error(data.error || 'quota_failed');
      renderQuota(data);
      if (data.remaining <= 0 && genBtn) {
        genBtn.disabled = true;
        if (quotaEl) quotaEl.textContent = `${data.quota} ücretsiz önizleme hakkınızın tamamını kullandınız.`;
      }
    } catch (err) {
      if (quotaEl) quotaEl.textContent = 'Hak bilgisi yüklenemedi.';
    }
  }
  function renderQuota(data) {
    if (quotaEl) quotaEl.innerHTML = `<strong>${data.remaining}</strong> / ${data.quota} ücretsiz önizleme hakkınız kaldı.`;
    if (quotaAfter) quotaAfter.innerHTML = `<strong>${data.remaining}</strong> / ${data.quota} ücretsiz önizleme hakkınız kaldı.`;
  }

  // ── File picker ───────────────────────────────────────────────────
  if (fileInput) {
    fileInput.addEventListener('change', () => {
      const f = fileInput.files && fileInput.files[0];
      if (f) handleFile(f);
    });
  }
  if (dropZone) {
    ['dragover', 'dragenter'].forEach((ev) => dropZone.addEventListener(ev, (e) => {
      e.preventDefault();
      dropZone.classList.add('is-drag');
    }));
    ['dragleave', 'drop'].forEach((ev) => dropZone.addEventListener(ev, (e) => {
      e.preventDefault();
      dropZone.classList.remove('is-drag');
    }));
    dropZone.addEventListener('drop', (e) => {
      const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) handleFile(f);
    });
  }
  function handleFile(f) {
    if (!/^image\/(jpeg|png|webp)$/i.test(f.type)) {
      alert('Lütfen JPEG, PNG veya WebP görsel seçin.');
      return;
    }
    if (f.size > 8 * 1024 * 1024) {
      alert('Görsel çok büyük (en fazla 8 MB).');
      return;
    }
    chosenFile = f;
    if (preview) {
      preview.src = URL.createObjectURL(f);
      preview.hidden = false;
    }
    if (dropInner) dropInner.style.display = 'none';
    if (genBtn) genBtn.disabled = false;
  }
  function resetUploadUI() {
    chosenFile = null;
    if (fileInput) fileInput.value = '';
    if (preview) { preview.src = ''; preview.hidden = true; }
    if (dropInner) dropInner.style.display = '';
    if (genBtn) genBtn.disabled = true;
  }

  // ── Generate ──────────────────────────────────────────────────────
  if (genBtn) {
    genBtn.addEventListener('click', () => {
      if (!chosenFile) return;
      submitGeneration(chosenFile);
    });
  }

  async function submitGeneration(file) {
    showState('loading');
    if (statusEl) statusEl.textContent = 'Fotoğrafınız yükleniyor…';

    const fd = new FormData();
    fd.append('wall_image', file, file.name || 'wall.jpg');
    fd.append('product_image_url', cfg.productImageUrl || '');

    try {
      if (statusEl) statusEl.textContent = 'Görselleştiriciye gönderiliyor…';
      const resp = await fetch(`${API_BASE}/generate`, {
        method: 'POST',
        credentials: 'include',
        body: fd,
      });
      const data = await resp.json();
      if (!resp.ok) {
        const map = {
          login_required: 'Bu özelliği kullanmak için giriş yapın.',
          quota_exceeded: 'Ücretsiz deneme hakkınız doldu.',
          rate_limited: 'Çok fazla istek — birkaç saniye bekleyin.',
          unsupported_format: 'JPEG, PNG veya WebP kullanın.',
          file_too_large: 'Görsel çok büyük (en fazla 8 MB).',
          generation_failed: 'Görselleştirici bu fotoğrafı işleyemedi. Farklı bir açı deneyin.',
          cloudinary_upload_failed: 'Sonuç kaydedilemedi. Tekrar deneyin.',
          bad_product_image_origin: 'Ürün görseli kaynağına izin verilmiyor.',
          product_image_fetch_failed: 'Ürün görseli alınamadı.',
          internal_error: 'Sunucu hatası. Tekrar deneyin.',
        };
        throw new Error(map[data.error] || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.');
      }
      // Success
      if (resultImg) resultImg.src = data.url;
      if (dlBtn) dlBtn.href = data.url;
      renderQuota(data);
      showState('result');
    } catch (err) {
      if (errMsg) errMsg.textContent = err.message || 'Bilinmeyen bir hata oluştu. Lütfen tekrar deneyin.';
      showState('error');
    }
  }
})();
